package tta.destinigo.talktoastro.feature_call_consultation.di

import org.koin.dsl.module
import tta.destinigo.talktoastro.feature_call_consultation.data.api.CallConsultationApi
import tta.destinigo.talktoastro.feature_call_consultation.data.api.QueueApiServiceImplementation
import tta.destinigo.talktoastro.feature_call_consultation.domain.CallConsultationInfoRepo
import tta.destinigo.talktoastro.feature_call_consultation.domain.QueueRepo
import tta.destinigo.talktoastro.feature_call_consultation.domain.SocketRepository
import tta.destinigo.talktoastro.feature_call_consultation.domain.VoIPCallRepo
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.QueueComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueStatusComponent

val callConsultationModule = module {
    factory { CallConsultationApi() }
    factory { CallConsultationInfoRepo(get()) }
    factory { VoIPCallRepo(get()) }
}


val queueModule = module {
    factory{ QueueApiServiceImplementation() }

    scope<QueueComponent> {
        scoped { QueueRepo(get()) }
    }

    scope<QueueStatusComponent> {
        scoped { QueueRepo(get()) }
        scoped { SocketRepository(get()) }
    }

}